import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';
import { UnsavedChangesGuard } from '../../shared/guards/unsaved-changes.guard';

export const advisorRoute: Route = {
  path: 'advisor',
  children: [
    {
      // Return URL from the external signing provider: only AuthGuard (parent) must run.
      // PermissionGuard would otherwise fail on a cold load before roles are in the store.
      path: 'account-onboarding/:id/sign-successful',
      loadComponent: () =>
        import('../account-onboarding/sign-successful/sign-successful.component').then(
          (c) => c.AccountOnboardingSignSuccessfulComponent,
        ),
    },
    {
      // The client is the signatory when the IFA onboarding has no Power of Attorney on file, so
      // this branch alone also allows Permission.CLIENT - everything else under /advisor stays
      // IFA/Front Office-only.
      path: 'account-onboarding',
      canActivate: [PermissionGuard],
      data: {
        permissions: [Permission.ONBOARDING_IFA, Permission.ONBOARDING_FRONT_OFFICE, Permission.CLIENT],
      },
      children: [
        {
          path: ':id',
          loadComponent: () =>
            import('../account-onboarding/account-onboarding.component').then(
              (c) => c.AccountOnboardingComponent,
            ),
        },
        {
          path: 'view/:id',
          loadComponent: () =>
            import('../account-onboarding/account-onboarding.component').then(
              (c) => c.AccountOnboardingComponent,
            ),
        },
      ],
    },
    {
      path: '',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.ONBOARDING_IFA, Permission.ONBOARDING_FRONT_OFFICE] },
      children: [
        { path: '', redirectTo: 'list', pathMatch: 'full' },
        {
          path: 'list',
          loadComponent: () =>
            import('./list.component').then((c) => c.AdvisorOnboardingListComponent),
        },
        {
          path: 'create',
          loadComponent: () =>
            import('../proposal/create/create.component').then((c) => c.ProposalCreateComponent),
          canDeactivate: [UnsavedChangesGuard],
        },
        {
          path: 'continue-approval/:id',
          loadComponent: () =>
            import('../proposal/create/create.component').then((c) => c.ProposalCreateComponent),
          canDeactivate: [UnsavedChangesGuard],
        },
        {
          path: 'onboarding',
          children: [
            {
              path: ':id',
              loadComponent: () =>
                import('../onboarding/onboarding.component').then((c) => c.OnboardingComponent),
            },
            {
              path: 'view/:id',
              loadComponent: () =>
                import('../onboarding/onboarding.component').then((c) => c.OnboardingComponent),
            },
          ],
        },
        {
          path: 'view/:id',
          loadComponent: () =>
            import('../onboarding/onboarding.component').then((c) => c.OnboardingComponent),
        },
        {
          path: 'preview/:id',
          loadComponent: () =>
            import('../proposal/create/create.component').then((c) => c.ProposalCreateComponent),
          canDeactivate: [UnsavedChangesGuard],
        },
      ],
    },
  ],
};
